
export class ApiRequestModelShow {
    public constructor() {
        this.method = '';
        this.url = '';
        this.insideRouting = '';
        this.requestString = '';
        this.request = '';
        this.responseError = '';
        this.responseErrorString = '';
        this.responseSuccess = '';
        this.responseSuccessString = '';
        this.curl = [];
        this.csharp = [];
        this.java=[];
        this.jQuery=[];
        this.kotlin=[];
        this.fileds=[];
        this.Python=[];
    }

    public method: string;
    public insideRouting: string;
    public url: string;
    public requestString: string;
    public request: string;
    public responseError: string;
    public responseErrorString: string;
    public responseSuccess: string;
    public responseSuccessString: string;
    public curl: string[];
    public csharp: string[];
    public java: string[];
    public jQuery: string[];
    public kotlin: string[];
    public Python: string[];

    public fileds:any[];
}
